/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */
import { fetchAccountLookup, getOutlookContacts, saveContact } from "../contacts/contact.service";
import { AuthData, PamsAuthResponse, SearchForEmailResponse } from "../auth/auth.model";
import { getStoredAuth, generateDeviceFingerprint, serverUrl, requestHeaders, requestHeaderWithAccessToken, checkPermissionToCreate, checkIfEmailAddressExist, showStatusMessage, logout, checkIfAttachmentExist, generateLinkToPams, generateIdFromEmail, isTimeToLogout, getUserShortName, hideStatusMessage } from "../auth/auth.service";
import { AccountLookup, ContactPersons, ContactInfoTypeEnum } from "../contacts/contact.model";
import { CheckAttachmentWithFilesResponse, OneDriveFilesList, OutlookAttachment, PamsFileData, RelatedToTypes, returnRelatedToTypes, Tag, TagsList, TypesList, TypesListForActivity } from "../attachement/attachement.model";
import { fetchCategoriesListForAttachment, fetchFilePermissionByTypeAndRelatedToId, fetchTagsListByType, getOutlookAttachmentContent, uploadFilesData, uploadFilesToOneDrive } from "../attachement/attachement.service";
import { Activities, ActivityEMailsTypesEnum, ActivityTypesEnum, checkEctivityMailResponse } from "../activity/activity.model";
import { checkMailActiivityWithConversationId, saveMailActiivity } from "../activity/activity.service";
import { AccountModel } from "../account/account.model";
import { saveAccount } from "../account/account.service";
import { checkIftherePamsCalendar, getAccessTokenStandard, getCalendarEvents, getPamsCalendar, matchingPamsCalendarWithOutlookCalendar } from "../calendar/calendar.service";
import { CALENDAR_VERSION } from "../calendar/version-check";
import { OutlookCalendarEvent, PamsCalendarResponse, PamsCalendarResponseDetails } from "../calendar/calendar.model";

/* global document, Office */

// Global state
let isProcessing = false;
let canCreateContact: boolean = false;
let canCreateAccount: boolean = false;
let canUploadFile: boolean = false;
let canCreateActivity: boolean = false;
let selectedAttachment: OutlookAttachment[] = [];
let selectedAttachmentContent: {content: string, format: any}[] = [];
let categoriesForAttachment: {Id: number, Name: string}[] = [];
let SelectedDataFiles: PamsFileData[] = [];
let UploadedFiles: File[] = [];
let tempSelectedAccount: AccountModel = new AccountModel();
let tempSelectedDataFiles: PamsFileData = new PamsFileData();
let SelectedActivity: Activities = new Activities();
let tagsList: TagsList[] = [];
let newTag:Tag = new Tag();
let tags:Tag[] = [];
let saveToPamsButton;
let attachmentBackupCheckBoxes: NodeList;
let emailAddressesCheckBoxes: NodeList;
let selectedEmailAddress: string;
let accountLookup;
let accountLookupOriginal;
let accountList: AccountLookup[] = [];
let moduleIdLookup;
let tagsListSearch;
let tagsListLookup;
let includingArchivedCheckBox;
let categoryLookup;
let addTagsButton;
let addContactButton;
let saveContactButton;
let saveDetailsButton;
let handleCalendarButton;
let wantToSaveEmail: boolean = false;
let wantToSaveAttachment: boolean = false;
let wantToSaveAccount: boolean = false;
let timeInterval;

//let selectedTagReferenceToTypeID: number = 0;
//let selectedTagReferenceToID: number = 0;
function checkIfTimeTologout(){
  timeInterval = setInterval(()=>{
    if(isTimeToLogout()){
      handleDisconnect();
    }
  }, 10000);
}
Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    console.log('Pams taskpane ready');
    console.log(`Calendar Service v${CALENDAR_VERSION.version} - Optimized: ${CALENDAR_VERSION.features.batchAPI}`);
    
    // Add version check to window for console access
    (window as any).checkVersion = () => {
      console.log('=== VERSION INFO ===');
      console.log('Version:', CALENDAR_VERSION.version);
      console.log('Batch API:', CALENDAR_VERSION.features.batchAPI ? '✅ Enabled' : '❌ Disabled');
      console.log('Build Date:', CALENDAR_VERSION.buildDate);
      return CALENDAR_VERSION;
    };
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "block";
    document.getElementById("pamsBody").style.backgroundColor = Office.context.officeTheme.bodyBackgroundColor;
    document.getElementById("app-body").style.color = Office.context.officeTheme.bodyForegroundColor;
    
    // Apply Office theme
    applyOfficeTheme();
    
    // Initialize UI
    initializeUI();
    
    // Initialize pinning state
    initializePinningState();
    
    // Handle item changes when taskpane is pinned
    setupItemChangeHandler();

    checkIfTimeTologout();
    // Check for existing authentication
    setTimeout(()=>{
      checkExistingAuth();
    }, 250);
  }
});
function userLoggedInToggole(){
  console.log(document.getElementById("userLoggedIn").classList.contains("show"))
  if(document.getElementById("userLoggedIn").classList.contains("show")){
    document.getElementById("userLoggedIn").classList.remove("show");
  }
  else{
    document.getElementById("userLoggedIn").classList.add("show");
  }
}
// Pinning state management
function initializePinningState() {
  // Native pinning support enabled in manifest with SupportsPinning=true
  console.log('Native pinning support enabled in manifest');
}
function setupItemChangeHandler() {
  if (Office.context.mailbox) {
    Office.context.mailbox.addHandlerAsync(
      Office.EventType.ItemChanged,
      onItemChanged,
      (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          console.log('Item change handler added successfully');
          console.log('Office', Office.context);
          console.log('Current item:', {
            conversationId: Office.context.mailbox.item?.conversationId,
            itemId: Office.context.mailbox.item?.itemId
          });
          document.getElementById("userLoggedIn").addEventListener("click", ()=>{ userLoggedInToggole() });
        } else {
          console.error('Failed to add item change handler:', result.error);
        }
      }
    );
  }
}
function onItemChanged(eventArgs: any) {
  console.log('Email item changed - updating UI');
  console.log('New item details:', { conversationId: Office.context.mailbox.item?.conversationId, itemId: Office.context.mailbox.item?.itemId, subject: Office.context.mailbox.item?.subject });
  // Clear previous status messages
  hideStatusMessage();
  /*const statusElements = ['emailAddressCheck_status', 'emailCheck-status', 'status-messages'];
  statusElements.forEach(id => {
    const element = document.getElementById(id);
    if (element) {
      element.innerHTML = '';
      element.className = element.className.replace(/status-(success|error|info)/g, '');
    }
  });*/
  // Hide action buttons
  const actionElements = [
    'addEmail-action',
    'updateEmail-action'
  ];
  
  actionElements.forEach(id => {
    const element = document.getElementById(id);
    if (element) {
      element.classList.add('hidden');
    }
  });
  
  // Update UI for new email if authenticated
  if (getStoredAuth()) {
    // Small delay to ensure new item is fully loaded
    setTimeout(() => {
      checkExistingAuth();
      resetAttachmentAndMailChoices();
    }, 100);
  }
  
  //showStatusMessage('Email changed: ' + (Office.context.mailbox.item?.subject || 'Untitled'), 'info');
}
function applyOfficeTheme() {
  const body = document.body;
  if (Office.context.officeTheme) {
    body.style.setProperty('--body-bg', Office.context.officeTheme.bodyBackgroundColor);
    body.style.setProperty('--body-fg', Office.context.officeTheme.bodyForegroundColor);
  }
}
function initializeUI() {
  // Authentication event listeners
  document.getElementById('login-btn')?.addEventListener('click', handleLogin);
  document.getElementById('disconnect-btn')?.addEventListener('click', handleDisconnect);
   
  // Email sync event listeners
  //document.getElementById('sync-current-email-btn')?.addEventListener('click', handleSyncCurrentEmail);
  //document.getElementById('sync-folder-btn')?.addEventListener('click', handleSyncEmailFolder);
}

// Authentication Functions
async function handleLogin() {
  if (isProcessing) return;
  
  //(document.getElementById('server-url') as HTMLInputElement)?.value?.trim();
  const Email = (document.getElementById('username') as HTMLInputElement)?.value?.trim();
  const Password = (document.getElementById('password') as HTMLInputElement)?.value;
  const RememberMe = false;
  const deviceInfo = generateDeviceFingerprint();

  if (!serverUrl || !Email || !Password) {
    showStatusMessage('Please fill in all fields', 'error');
    return;
  }
  const loginBtn = document.getElementById('login-btn') as HTMLButtonElement;
  loginBtn.disabled = true;
  loginBtn.textContent = 'Connecting...';

  try {
    ShowLoading();
    //showStatusMessage('Connecting to Pams...', 'info');

    const response = await fetch(`${serverUrl}security/userlogin/enhancedlogin`, {
      method: 'POST',
      headers: requestHeaders,
      body: JSON.stringify({ Email, Password, RememberMe, deviceInfo })
    });

    if (!response.ok) {
      throw new Error(`Authentication failed: ${response.status} ${response.statusText}`);
    }

    const data: PamsAuthResponse = await response.json();
    if (!data.accessToken || !data.refreshToken || !data.user) {
      throw new Error('Authentication failed - invalid response');
    }

    // Store authentication data
    const authData: AuthData = {
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
      user: data.user,
      expiresAt: data.expiresAt
    };
    localStorage.setItem('pamsAuth', JSON.stringify(authData));
    
    // Update UI
    showConnectedState(authData);
    //showStatusMessage(`Successfully connected to Pams as ${data.user.DisplayName}`, 'success');
    
    setTimeout(()=>{
      checkExistingAuth();
      checkIfTimeTologout();
    }, 1000);

  } catch (error) {
    console.error('Login error:', error);
    showStatusMessage(`Login failed: ${error instanceof Error ? error.message : 'Unknown error'}`, 'error');
  } finally {
    HideLoading();
    loginBtn.disabled = false;
    loginBtn.textContent = 'Connect to Pams';
  }
}

function handleDisconnect() {
  logout();
  showLoginState();
  clearInterval(timeInterval);
  //showStatusMessage('Disconnected from Pams', 'info');
}

export function checkExistingAuth() {
  const authData = getStoredAuth();
  if (authData) {
    showConnectedState(authData);
    //loadContactStats();
    setTimeout(()=>{
      loadCalendarCheckSection();
      loadEmailAddressCheckSection();
      loadEmailCheckSection();
      loadattachmentCheckSection();
      handleCalendarButton = document.getElementById("handleCalendarButton");
      handleCalendarButton.disabled = true;
      handleCalendarButton.addEventListener("click", ()=>{ handleCalendarFiltered() });
      //document.getElementById("handleCalendarButton").addEventListener("click", ()=>{ handleSavingAppointments() });
    }, 250);
  }
}

// UI State Management
function showLoginState() {
  document.getElementById('auth-section')?.classList.remove('hidden');//login-form
  document.getElementById('userLoggedIn')?.classList.add('hidden');
  document.getElementById('disconnect-btn')?.classList.add('hidden');
  document.getElementById('sync-section')?.classList.add('hidden');
  document.getElementById('email-section')?.classList.add('hidden');
  document.getElementById('emailAddressCheck')?.classList.add('hidden');
  document.getElementById('calendarCheck')?.classList.add('hidden');
  document.getElementById('emailBackupCheck')?.classList.add('hidden');
  backToLandingSection();
}
function showConnectedState(authData: AuthData) {
  document.getElementById('auth-section')?.classList.add('hidden');//login-form
  document.getElementById('userLoggedIn')?.classList.remove('hidden');
  document.getElementById('disconnect-btn')?.classList.remove('hidden');
  document.getElementById('sync-section')?.classList.remove('hidden');
  document.getElementById('email-section')?.classList.remove('hidden');
  document.getElementById('emailAddressCheck')?.classList.remove('hidden');
  document.getElementById('calendarCheck')?.classList.remove('hidden');
  document.getElementById('emailBackupCheck')?.classList.remove('hidden');
  backToLandingSection()
  // Update connection info
  const serverElement = document.getElementById('connected-server');
  const userElement = document.getElementById('connected-user');
  const timeElement = document.getElementById('connected-time');
  
  if (serverElement) serverElement.textContent = `Welcome ${authData.user.DisplayName}`;
  if (userElement) userElement.textContent = getUserShortName(authData.user.DisplayName);
  if (timeElement) timeElement.textContent = new Date(authData.expiresAt).toLocaleString();
}

function ShowLoading(){
  isProcessing = true;
  document.getElementById("loadingOverlay").style.display = "Block";
}
function HideLoading(){
  isProcessing = false;
  document.getElementById("loadingOverlay").style.display = "none";
}
/* calendar section */
async function loadCalendarCheckSection(){
  checkIftherePamsCalendar().then(
    (value: number)=>{
        console.log("loadCalendarCheckSection", value);
      if(value){
        handleCalendarButton.disabled = false;
      }
    }).catch(
      (error)=>{
      console.error("loadCalendarCheckSection", error);
    });
}
async function handleCalendarFiltered():Promise<{success: boolean, value: OutlookCalendarEvent[]}> {
  handleCalendarButton.disabled = true;
  try {
    ShowLoading();
      getPamsCalendar().then(
        (pamsCalendar: PamsCalendarResponse) => {
          HideLoading();
          if (pamsCalendar) {
            console.log("getPamsCalendar", pamsCalendar);
            getAccessTokenStandard()
              .then((tokenValue) => {
                console.log("Access token acquired successfully");
                const startDate = new Date();
                const endDate = new Date();
                endDate.setFullYear(startDate.getFullYear() + 1);//Maximum number of days: 1825"
                getCalendarEvents(startDate, endDate, tokenValue)
                  .then((events: OutlookCalendarEvent[]) => {
                    console.log( "Outlook calendar:", events.filter((x) => x.transactionId));
                    matchingPamsCalendarWithOutlookCalendar(pamsCalendar, events.filter((x) => x.transactionId));
                  })
                  .catch(() => {
                    //
                  });
              })
              .catch((tokenError) => {
                showStatusMessage(`${tokenError instanceof Error ? tokenError.message : 'Miscrosoft outlook token error'}`, "error");
              });
          }
        },
        (error) => {
          showStatusMessage("Error occurred while processing your request", "error");
          HideLoading();
        }
      );
  } catch (error) {
    console.error('Catch calendar operation failed:', error);
    return {
      success: false,
      value: error.message
    };
  }
}
/* Email address section */
async function loadEmailAddressCheckSection() {
  const item = Office.context.mailbox.item;
  //document.getElementById('emailToCheckBoxLabel').innerHTML = "Sender: " + item.from.emailAddress;
  const outlookMailAddressHTML = document.getElementById("outlookCCMailAddress");// as HTMLTableRowElement;
  const allCCMails = (item && item.cc)? item.cc : [];
  const allToMails = (item && item.to)? item.to : [];
  const allFromMails = (item && item.from)? item.from: null;
  const insertedEmailAddress: string[] = [];
  if (outlookMailAddressHTML && item) {
    //let totalIndex:number = 0;
    outlookMailAddressHTML.innerHTML = "";
    outlookMailAddressHTML.innerHTML = `<tr id="rowMail-${generateIdFromEmail(allFromMails.emailAddress)}" class="">
    <td><div id="tooltipHolder-${generateIdFromEmail(allFromMails.emailAddress)}" class="tltipHolder"><label><input type="radio" id="${generateIdFromEmail(allFromMails.emailAddress)}" data-type="mailFrom" name="mailAddressCheck" value="${allFromMails.emailAddress}" /><span class="emphasisContent">Sender: ${allFromMails.emailAddress}</span></label><div class="tltip left" id="tooltip-${generateIdFromEmail(allFromMails.emailAddress)}"></div></div></td>
    <td width="76px"><div class="status-message status-info _status-error _status-success margin-0" id="status-${generateIdFromEmail(allFromMails.emailAddress)}">Checking.. </div></td></tr>`;
    //<tr id="row-${generateIdFromEmail(allFromMails.emailAddress)}"><td colspan="2" id="result-${generateIdFromEmail(allFromMails.emailAddress)}"></td></tr>
    insertedEmailAddress.push(allFromMails.emailAddress);
    emailAddressesCheckBoxes = (document.getElementsByName("mailAddressCheck"));
    if (allToMails && allToMails.length) {
      allToMails.forEach((file, index) => {
        if (file.emailAddress) {
          if(insertedEmailAddress.findIndex(x=> x == file.emailAddress) == -1){
            //emailAddressesCheckBoxes.forEach((input, index)=>{
              //if((input as HTMLInputElement).value != file.emailAddress){
                if (file.emailAddress != Office.context.mailbox.userProfile.emailAddress) {
                  const rowElement = `<tr id="rowMail-${generateIdFromEmail(file.emailAddress)}" class="">
                  <td><div id="tooltipHolder-${generateIdFromEmail(file.emailAddress)}" class="tltipHolder"><label><input type="radio" id="${generateIdFromEmail(file.emailAddress)}" data-type="mailTo" name="mailAddressCheck" value="${file.emailAddress}" /><span class="emphasisContent">To: ${file.emailAddress}</span></label><div class="tltip left" id="tooltip-${generateIdFromEmail(file.emailAddress)}"></div></div></td>
                  <td width="76px"><div class="status-message status-info _status-error _status-success margin-0" id="status-${generateIdFromEmail(file.emailAddress)}">Checking.. </div></td> 
                  </tr>`;
                  //<tr id="row-${generateIdFromEmail(file.emailAddress)}"><td colspan="2" id="result-${generateIdFromEmail(file.emailAddress)}"></td></tr>
                  outlookMailAddressHTML.innerHTML += rowElement;
                  insertedEmailAddress.push(file.emailAddress);
                }
              //}
            //});
          }
        }
      });
    }

    if (allCCMails && allCCMails.length) {
      allCCMails.forEach((file, index) => {
        if (file.emailAddress && file.emailAddress != Office.context.mailbox.userProfile.emailAddress) {
          //emailAddressesCheckBoxes.forEach((input, index)=>{
            //if((input as HTMLInputElement).value != file.emailAddress){
              //if () {
                const rowElement = `<tr id="rowMail-${generateIdFromEmail(file.emailAddress)}" class="">
                <td><div id="tooltipHolder-${generateIdFromEmail(file.emailAddress)}" class="tltipHolder"><label><input type="radio" id="${generateIdFromEmail(file.emailAddress)}" data-type="mailCC" name="mailAddressCheck" value="${file.emailAddress}" /><span class="emphasisContent">CC: ${file.emailAddress}</span></label><div class="tltip left" id="tooltip-${generateIdFromEmail(file.emailAddress)}"></div></div></td>
                <td width="76px"><div class="status-message status-info _status-error _status-success margin-0" id="status-${generateIdFromEmail(file.emailAddress)}">Checking.. </div></td> 
                </tr>`;
                //<tr id="row-${generateIdFromEmail(file.emailAddress)}"><td colspan="2" id="result-${generateIdFromEmail(file.emailAddress)}"></td></tr>
                outlookMailAddressHTML.innerHTML += rowElement;
                insertedEmailAddress.push(file.emailAddress);
              //}
            //}
          //});
        }
      });
    }
  }
  addContactButton = document.getElementById("addContact-action") as HTMLButtonElement;
  addContactButton.disabled = true;
  if(emailAddressesCheckBoxes){
    emailAddressesCheckBoxes.forEach((input, index)=>{
      (input as HTMLInputElement).addEventListener("change", ()=>{ onRadioBoxClicked() });
    });
  }
  try {
    ShowLoading();
    checkPermissionToCreate("contact").then((value:any) => {
      HideLoading();
      canCreateContact = (value)? value.Result : false;
    if(canCreateContact){
      addContactButton.onclick = addContact_action;
    }
    else{
      addContactButton.disabled = true;
    }
    },
    (error) => {
      showStatusMessage("Error occurred while processing your request", "error");
      HideLoading();
    });
    checkPermissionToCreate("account").then((value:any) => {
    HideLoading();
    canCreateAccount = (value)? value.Result : false;;
    },
    (error) => {
      showStatusMessage("Error occurred while processing your request", "error");
      HideLoading();
    });
  } catch {
    //
  }
  setTimeout(()=>{
    document.getElementsByName("backToLandingSection-action").forEach((item)=>{
      item.onclick = backToLandingSection
    });
    detectEmailAddressForChecking();
  }, 1000);
}
function detectEmailAddressForChecking(){
  try {
    const item = Office.context.mailbox.item;
    // Handle case when no email is selected
    if (!item || !item.from) {
      return;
    }
    for (let index = 0; index < emailAddressesCheckBoxes.length; index++){
      const emailAddressInput = (emailAddressesCheckBoxes[index] as HTMLInputElement);
      const tooltipHolderDiv = document.getElementById(`tooltipHolder-${generateIdFromEmail(emailAddressInput.value)}`);
      const findRowResult = document.getElementById(`tooltip-${generateIdFromEmail(emailAddressInput.value)}`);
      ShowLoading();
      checkIfEmailAddressExist(emailAddressInput.value).then(
        (value: SearchForEmailResponse[]) => {
          HideLoading();
          if (value && value.length) {
            const find = value.filter(x=> x.Email == emailAddressInput.value);
            if(find.length){
              //Found
              document.getElementById(`status-${generateIdFromEmail(emailAddressInput.value)}`)?.classList.remove("status-info");
              //document.getElementById(`status-${generateIdFromEmail(emailAddressInput.value)}`)?.classList.add("status-success");
              document.getElementById(`status-${generateIdFromEmail(emailAddressInput.value)}`).innerHTML = "";//Exists
              document.getElementById(`${generateIdFromEmail(emailAddressInput.value)}`)?.remove();
              if(tooltipHolderDiv) tooltipHolderDiv.classList.add("withTooltip");
              findRowResult.innerHTML = ``;
              if(find[0].Name){
                findRowResult.innerHTML += `<div class="">Name: ${find[0].Name}</div>`;
              }
              if(find[0].RelatedTo){
                findRowResult.innerHTML += `<div class="">Company: ${find[0].RelatedTo}</div>`;
              }
              if(find[0].Mobiles && find[0].Mobiles.length){
                find[0].Mobiles.forEach((mobile, index)=>{
                  findRowResult.innerHTML += `<div>Mobile: ${mobile}</div>`;
                });
              }
              else{
                  findRowResult.innerHTML += `<div>Mobile: N/A</div>`;
              }
              if(find[0].Phones && find[0].Phones.length){
                find[0].Phones.forEach((phone, index)=>{
                  if(findRowResult) findRowResult.innerHTML += `<div>Phone: ${phone}</div>`;
                });
              }
              else{
                  //findRowResult.innerHTML += `<div>Phone: N/A</div>`;
              }
            }
          } else {
            document.getElementById(`status-${generateIdFromEmail(emailAddressInput.value)}`)?.classList.remove("status-info");
            document.getElementById(`status-${generateIdFromEmail(emailAddressInput.value)}`).innerHTML = "";
            if(findRowResult) findRowResult.remove();
          }
        },
        (error) => {
          showStatusMessage("Error occurred while processing your request", "error");
          HideLoading();
        }
      );
    }
    /*checkIfEmailAddressExist(item.from.emailAddress).then(
      (value: SearchForEmailResponse[]) => {
        if (value && value.length) {
          //document.getElementById("emailAddressCheck_status").classList.add("status-success");
          document.getElementById("emailAddressCheck_status").innerHTML = "";//Exists
          document.getElementById("emailToCheckBox").remove();
        } else {
          document.getElementById("emailAddressCheck_status")?.classList.add("status-error");
          document.getElementById("emailAddressCheck_status").innerHTML = "Not exists";
        }
        //for (let index = 0; index < item.cc.length; index++){
      },
      (error) => {
        showStatusMessage("Error occurred while processing your request", "error");
      }
    );*/
  } catch (error) {
    console.error('Failed to load contact stats:', error);
    HideLoading();
  }
}
async function loadattachmentCheckSection() {
  const item = Office.context.mailbox.item;
  //const outlookAttachmentHTML = document.getElementById("outlookAttachmentHTML");// as HTMLTableRowElement;
  const outlookAttachmentHTML = document.getElementById("outlookAttachmentHTML2");// as HTMLTableRowElement;
  const allAttachments = (item && item.attachments)? item.attachments : [];//await getAllMailAttachments();
  if (outlookAttachmentHTML && allAttachments && allAttachments.length) {
    const attachmentIds:string[]= [];
    outlookAttachmentHTML.innerHTML = "";
    allAttachments.forEach((file, index) => {
      if(!file.isInline){
        attachmentIds.push(file.id);
        const fileSize = (file.size)? file.size  / 1024: 0;
        const rowElement = `<tr id="${file.id}" class="">
        <td width="200px"><div id="tooltipHolder-${file.id}" class="tltipHolder"><label><input type="checkbox" data-type="attachment" name="attachmentBackupCheck" value="${file.id}" /><span class="emphasisContent">${file.name} (${(file.size)? +fileSize.toFixed(0): 0} KB)</span></label><div class="tltip left" id="tooltip-${file.id}"></div></div></td>
        <td width="76px"><div class="status-message status-info _status-error _status-success margin-0" id="status-${file.id}">Checking.. </div></td> 
        </tr>
        <tr class="hidden" id="row-${file.id}"><td colspan="2" id="result-${file.id}"></td></tr>`;
        outlookAttachmentHTML.innerHTML += rowElement;
      }
    });
    //const uploadFileButton = document.getElementById("upload-action") as HTMLButtonElement;
    try {
      ShowLoading();
      checkPermissionToCreate("uploadFiles").then(
        (value:any) => {
          HideLoading();
          canUploadFile = (value)? value.Result : false;;
          detectAttachmentForChecking(attachmentIds);
        },
        (error) => {
          showStatusMessage("Error occurred while processing your request", "error");
          detectAttachmentForChecking(attachmentIds);
          HideLoading();
        });
    } catch {
      //
    }
  }
  attachmentBackupCheckBoxes = (document.getElementsByName("attachmentBackupCheck"));
  attachmentBackupCheckBoxes.forEach((input, index)=>{
    (input as HTMLInputElement).addEventListener("change", ()=>{ onCheckBoxClicked() });
  });
  saveToPamsButton = (document.getElementById("saveToPams-action") as HTMLButtonElement);
  saveToPamsButton.disabled = true;
  saveToPamsButton.addEventListener("click", ()=>{ addDetailsForAttachmentAndMail(); });
}
function detectAttachmentForChecking(attachmentIds:string[]){
  try {
    const item = Office.context.mailbox.item;
    // Handle case when no email is selected
    if (!item || !item.attachments) {
      return;
    }
    if(attachmentIds && attachmentIds.length){
      const Inputs = (document.getElementsByName(`attachmentBackupCheck`));
      ShowLoading();
      checkIfAttachmentExist(attachmentIds).then(
        (value: CheckAttachmentWithFilesResponse[]) => {
          HideLoading();
          if(value){
            if (item.attachments) {
              item.attachments.forEach((file, index) => {
                if (!file.isInline) {
                  const findRow = document.getElementById(`row-${file.id}`);
                  findRow.innerHTML = `<td colspan="2" id="result-${file.id}"></td>`;
                  const tooltipHolderDiv = document.getElementById(`tooltipHolder-${file.id}`);
                  const findRowElement = document.getElementById(file.id);
                  const findRowResult = document.getElementById(`tooltip-${file.id}`);
                  //const findRowResult = document.getElementById(`result-${file.id}`);
                  const findRowStatus = document.getElementById(`status-${file.id}`);
                  const findIndex:number = value.findIndex(x=> x.OutlookId == file.id);
                  if(findIndex > -1){
                    findRowStatus.classList.remove("status-info");
                    //findRowStatus.classList.add("status-success");
                    findRowStatus.innerHTML = ``;//Exists
                    findRowResult.innerHTML = ``;
                    if(tooltipHolderDiv) tooltipHolderDiv.classList.add("withTooltip");
                    //findRow.classList.add("status-message");
                    //findRow.classList.add("status-success");
                    Inputs.forEach((input, index) => {
                      if ((input as HTMLInputElement).value == value[findIndex].OutlookId) {
                        input.remove();
                      }
                    });
                    value[findIndex].LinkedTo.forEach((link, index)=>{
                      //findRowStatus.innerHTML += `<a class="_btn small multiOptionDiv" target="_blank" href="${generateLinkToPams(link.RelatedToTypeId, link.RelatedToId)}" title="${returnRelatedToTypes(link.RelatedToTypeId)}: ${link.RelatedToNo}">${returnRelatedToTypes(link.RelatedToTypeId)}: ${link.RelatedToNo}</a>`;
                      findRowResult.innerHTML += `<a class="small multiOptionDiv" target="_blank" href="${generateLinkToPams(link.RelatedToTypeId, link.RelatedToId)}" title="${returnRelatedToTypes(link.RelatedToTypeId)}: ${link.RelatedToNo}">${returnRelatedToTypes(link.RelatedToTypeId)}: ${link.RelatedToNo}</a>`;
                    });
                  }
                  else{
                    findRowStatus.classList.remove("status-info");
                    //findRowStatus.classList.add("status-error");
                    findRowStatus.innerHTML = ``;
                    //findRowStatus.innerHTML = `<button id="addAttachment-${file.id}" class="btn small btn-primary">Add to Pams</button>`;
                    //findRowResult.innerHTML = ``;
                  }
                }
              });
              if (canUploadFile) {
              } else {
                Inputs.forEach((input, index) => {
                  if (input) {
                    input.remove();
                  }
                });
              }
            }
          }
        },
        (error) => {
          showStatusMessage("Error occurred while processing your request", "error");
          HideLoading();
        }
      );
    }
  } catch (error) {
    console.error('Failed to load contact stats:', error);
    HideLoading();
  }
}
function addContact_action(){
  document.getElementById("landingSection").style.display = "none";
  document.getElementById('addDetailsToPamsSection').style.display = "none";
  document.getElementById('addAccountSection').style.display = "none";
  document.getElementById("addContactSection").style.display = "block";
  saveContactButton = document.getElementById("saveContact-action");
  saveContactButton.addEventListener("click", ()=>{ saveContact_check() });
  accountLookup = document.getElementById("accountLookup") as HTMLSelectElement;
  //accountLookupOriginal = document.getElementById("accountLookupOriginal") as HTMLSelectElement;
  accountLookup.disabled = true;
  accountLookup.addEventListener("change", ()=>{ onAccountLookupChnage(accountLookup.value) });
  // initialize search input
  
  selectedEmailAddress = "";
  emailAddressesCheckBoxes.forEach((input, index)=>{
    const attribute = (input as HTMLInputElement).getAttribute("data-type");
    if((input as HTMLInputElement).checked){
      if(attribute == "mailFrom"){
        selectedEmailAddress = Office.context.mailbox.item.from.emailAddress;
        /*if(Office.context.mailbox.item.from.displayName && !Office.context.mailbox.item.from.displayName.includes("@")){
          (document.getElementById('Name') as HTMLInputElement).value = (Office.context.mailbox.item.from.displayName);
        }*/
      }
      else if(attribute == "mailTo"){
        const findIndex = Office.context.mailbox.item.to.findIndex(x=> x.emailAddress == (input as HTMLInputElement).value);
        if(findIndex > -1){
          selectedEmailAddress = Office.context.mailbox.item.to[findIndex].emailAddress;
          /*if(Office.context.mailbox.item.to[findIndex].displayName && !Office.context.mailbox.item.to[findIndex].displayName.includes("@")){
            (document.getElementById('Name') as HTMLInputElement).value = Office.context.mailbox.item.to[findIndex].displayName;
          }*/
        }
      }
      else if(attribute == "mailCC"){
        const findIndex = Office.context.mailbox.item.cc.findIndex(x=> x.emailAddress == (input as HTMLInputElement).value);
        if(findIndex > -1){
          selectedEmailAddress = Office.context.mailbox.item.cc[findIndex].emailAddress;
          /*if(Office.context.mailbox.item.cc[findIndex].displayName && !Office.context.mailbox.item.cc[findIndex].displayName.includes("@")){
            (document.getElementById('Name') as HTMLInputElement).value = Office.context.mailbox.item.cc[findIndex].displayName;
          }*/
        }
      }
    }
  });
  (document.getElementById('Email') as HTMLInputElement).value = selectedEmailAddress;
  if(!(document.getElementById('Name') as HTMLInputElement).value || (document.getElementById('Name') as HTMLInputElement).value == null || (document.getElementById('Name') as HTMLInputElement).value == ""){
    //(document.getElementById('Name') as HTMLInputElement).value = (Office.context.mailbox.item.from.emailAddress).split("@")[0];
  }
  function fillAccountSelectBox() {
    try {
      accountList = [];
      ShowLoading();
      fetchAccountLookup().then((value: any[]) => {
        HideLoading();
        if (value) {
          accountLookup.innerHTML = "";
          if (canCreateAccount) {
            //accountList.push({ID: -1, Name: "Add new", FullName: "Add new"});
          }
          accountList = accountList.concat(value);
          if (accountLookup) {
            accountList.forEach((acc, index) => {
              const messageElement = document.createElement("option");
              messageElement.value = acc.ID.toString();
              messageElement.innerHTML = acc.Name;
              accountLookup.appendChild(messageElement);
              //accountLookupOriginal.appendChild(messageElement);
            });
            accountLookup.disabled = false;
            initializeSearchableSelect('accountLookupSearch', 'accountLookup', accountLookup.options, accountList, "ID", ["Name"], (canCreateAccount)? true: false, false);
          }
          console.log("accountList: ", accountList);
        }
      },
      (error) => {
        showStatusMessage("Error occurred while processing your request", "error");
        HideLoading();
      });
    } catch {
      HideLoading();
    }
  }
  if (canCreateContact) {
    fillAccountSelectBox();
  }
}
function saveContact_check(){
  (saveContactButton as HTMLButtonElement).disabled = true;
  if(wantToSaveAccount){
    saveAccount_action()
  }
  else{
    saveContact_action();
  }
}
function saveContact_action(relatedToId?: number){
  const contactPerson: ContactPersons = {
    Title: (document.getElementById('Title') as HTMLInputElement)?.value,
    Name: (document.getElementById('Name') as HTMLInputElement)?.value,
    CompanyBranchID: getStoredAuth().user.CompanyBranchID,
    ContactPersonRelatedTypeID: 2,
    RelatedToID: (relatedToId)? relatedToId : +((accountLookup as HTMLSelectElement)?.value),
    Department: (document.getElementById('Department') as HTMLInputElement)?.value,
    Postion: (document.getElementById('Postion') as HTMLInputElement)?.value,
    ContactInfoList:[
      {
        ContactInfoTypeID: ContactInfoTypeEnum.Email,
        ContactInfoValue: selectedEmailAddress,
        Name: "Email"
      },
      {
        ContactInfoTypeID: ContactInfoTypeEnum.Mobile,
        ContactInfoValue: (document.getElementById('Mobile') as HTMLInputElement)?.value,
        Name: "Mobile"
      }
    ]
  };
  try {
    if(contactPerson && contactPerson.RelatedToID && contactPerson.Name){
      ShowLoading();
      saveContact(contactPerson).then(
        (value) => {
          HideLoading();
          if (value ) {
            backToLandingSection();
            checkExistingAuth();
          }
        },
        (error) => {
          (saveContactButton as HTMLButtonElement).disabled = false;
          showStatusMessage("Error occurred while processing your request", "error");
          HideLoading();
        }
      );
    }
    else{
      (saveContactButton as HTMLButtonElement).disabled = false;
      showStatusMessage("Validation error", "error");
    }
  } catch (error) {
    console.error('Failed to load contact stats:', error);
    HideLoading();
  }
}
function addAccount_action(){
  /*document.getElementById('landingSection').style.display = "none";
  document.getElementById("addContactSection").style.display = "none";
  document.getElementById('addDetailsToPamsSection').style.display = "none";
  document.getElementById('addAccountSection').style.display = "block";*/
  tempSelectedAccount = new AccountModel();
}
function saveAccount_action(){
  try {
    tempSelectedAccount.Name = (document.getElementById("newAccount") as HTMLInputElement).value;
    tempSelectedAccount.FullName = (document.getElementById("newAccount") as HTMLInputElement).value;
    if(tempSelectedAccount && tempSelectedAccount.Name){
      ShowLoading();
      saveAccount(tempSelectedAccount).then(
        (value: number) => {
          if (value) {
            saveContact_action(value);
          }
          else{
            HideLoading();
          }
        },
        (error) => {
          (saveContactButton as HTMLButtonElement).disabled = false;
          showStatusMessage("Error occurred while processing your request", "error");
          HideLoading();
        }
      );
    }
    else{
      (saveContactButton as HTMLButtonElement).disabled = false;
      showStatusMessage("Validation error", "error");
    }
  } catch (error) {
    console.error('Failed to load contact stats:', error);
    HideLoading();
  }
}
function onAccountLookupChnage(value: string){
  console.log("onAccountLookupChnage: ", value);
  if(value == "-1"){
    wantToSaveAccount = true;
    document.getElementById("newAccountSection").classList.remove("hidden");
    if(canCreateAccount){
      addAccount_action();
    }
    else{
      showStatusMessage("You don't have a permission", "error");
    }
  }
  else{
    wantToSaveAccount = false;
    document.getElementById("newAccountSection").classList.add("hidden");
  }
}
function backToLandingSection(){
  document.getElementById('addContactSection').style.display = "none";
  document.getElementById('addAccountSection').style.display = "none";
  document.getElementById('addDetailsToPamsSection').style.display = "none";
  document.getElementById('landingSection').style.display = "block";
}
function onCheckBoxClicked(){
  if(attachmentBackupCheckBoxes && saveToPamsButton){
    saveToPamsButton.disabled = true;
    attachmentBackupCheckBoxes.forEach((input, index)=>{
      if((input as HTMLInputElement).checked){
        saveToPamsButton.disabled = false;
      }
    });
  }
}
function onRadioBoxClicked(){
  if(emailAddressesCheckBoxes && addContactButton){
    addContactButton.disabled = true;
    emailAddressesCheckBoxes.forEach((input, index)=>{
      if((input as HTMLInputElement).checked){
        addContactButton.disabled = false;
      }
    });
  }
}
function addAttachment_action() {
  tempSelectedDataFiles = new PamsFileData();
  tempSelectedDataFiles.FileTags = [];
  console.log("addAttachment_action", selectedAttachment);
}
function addTags(relatedToType: number, relatedToId: number){
  if(relatedToType && relatedToId){
    newTag = new Tag();
    newTag.TagRelatedToID = 0;
    newTag.TagRelatedTypeID = 1;
    newTag.ReferenceToID = relatedToId;
    newTag.ReferenceToTypeID = relatedToType;
    newTag.TagContent = RelatedToTypes[relatedToType]+ ": " + tagsList.filter(c => c.ID == relatedToId)[0].Name;
    if(!tags || !tags.length){
      tags = [];
    }
    if(tags && tags.findIndex(ft => ft.ReferenceToID == newTag.ReferenceToID && ft.ReferenceToTypeID == newTag.ReferenceToTypeID) == -1){
      tags.push(newTag);
      drowSelectedTags();
      (saveDetailsButton as HTMLButtonElement).disabled = false;
    }
    //(document.getElementById("moduleIdLookup") as HTMLSelectElement).value = "";
  }
}
function removeTag(relatedToType: number, relatedToId: number){
  if(tags && tags.length){
    const findIndex = tags.findIndex(x=> x.ReferenceToTypeID == relatedToType && x.ReferenceToID == relatedToId);
    if(findIndex > -1){
      tags.splice(findIndex, 1);
      drowSelectedTags();
    }
  }
}
function drowSelectedTags(){
  const selectedTagsHTML = document.getElementById("selectedTags");
  selectedTagsHTML.innerHTML = "";
  if(tags && tags.length){
    tags.forEach((item, index)=>{
      const newTagHTML = `<div class="multiOptionDiv" title="${item.TagContent}">${item.TagContent} <a id="tag-${index + 1}" class="close">&times;</a></div>`;
      selectedTagsHTML.innerHTML += newTagHTML;
      document.getElementById(`tag-${index + 1}`).addEventListener("click", ()=> { removeTag(item.ReferenceToTypeID, item.ReferenceToID) });
    })
  }
}
function SaveFiles_action(withExtraTag?: Tag[]) {
  function base64ToFile(base64Data: string, fileName: string): File {
    // Remove data URL prefix if present
    const base64 = base64Data.replace(/^data:[^;]+;base64,/, "");

    // Convert base64 to byte array
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // Create File object
    return new File([byteArray], fileName, {
      type: getMimeType(fileName), // Optional: determine MIME type
    });
  }
  function getMimeType(fileName: string): string {
    const extension = fileName.split(".").pop()?.toLowerCase();
    const mimeTypes: { [key: string]: string } = {
      pdf: "application/pdf",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      png: "image/png",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      txt: "text/plain",
    };

    return mimeTypes[extension || ""] || "application/octet-stream";
  }
  try {
    UploadedFiles = [];
    SelectedDataFiles = [];
    for (let index = 0; index < selectedAttachment.length; index++) {
      tempSelectedDataFiles.ParentFileID = 0;
      tempSelectedDataFiles.FileType = "File";
      tempSelectedDataFiles.FileTypeId = 3;
      tempSelectedDataFiles.CompanyBranchID = getStoredAuth().user.CompanyBranchID;
      tempSelectedDataFiles.CompanyID = getStoredAuth().user.CompanyID;
      tempSelectedDataFiles.UserId = getStoredAuth().user.PersonID;
      tempSelectedDataFiles.CreatedByID = getStoredAuth().user.PersonID;
      tempSelectedDataFiles.CreationDate = new Date();
      tempSelectedDataFiles.ModificationDate = new Date();
      tempSelectedDataFiles.ModificatedByID = getStoredAuth().user.PersonID;
      tempSelectedDataFiles.FileCategoryId = +(document.getElementById("categoryLookup") as HTMLSelectElement).value;
      tempSelectedDataFiles.FileName = selectedAttachment[index].name;
      tempSelectedDataFiles.FileTitle = selectedAttachment[index].name;
      tempSelectedDataFiles.SizeInBytes = selectedAttachment[index].size;
      tempSelectedDataFiles.OutlookItemId = selectedAttachment[index].id;
      tempSelectedDataFiles.FileTags = tags;
      if(withExtraTag && withExtraTag.length) {
        for (let tag of withExtraTag) {
          if (tempSelectedDataFiles.FileTags && tempSelectedDataFiles.FileTags.findIndex((x) => x.ReferenceToID == tag.ReferenceToID && x.ReferenceToTypeID == tag.ReferenceToTypeID) == -1) {
            tempSelectedDataFiles.FileTags.push(tag);
          }
        }
      }
      UploadedFiles.push(base64ToFile(selectedAttachmentContent[index].content, selectedAttachment[index].name));
      SelectedDataFiles.push(tempSelectedDataFiles);
    }
    if (SelectedDataFiles && SelectedDataFiles.length) {
      ShowLoading();
      uploadFilesToOneDrive(SelectedDataFiles, UploadedFiles).then(
        (value: OneDriveFilesList[]) => {
          if (value) {
            for (let v of value) {
              tempSelectedDataFiles.CloudItemId = v.id;
              tempSelectedDataFiles.UploadedFileID = v.name;
              tempSelectedDataFiles.FilePath = v.webUrl;
              tempSelectedDataFiles.CloudItemPath = v.webUrl;
              tempSelectedDataFiles.FileTitle = v.title;
              tempSelectedDataFiles.FileName = v.title;
              tempSelectedDataFiles.SizeInBytes = v.fileLength;
            }
            try {
              uploadFilesData(SelectedDataFiles).then((value2: PamsFileData[]) => {
                HideLoading();
                backToLandingSection();
                checkExistingAuth();
              },
              (error) => {
                (saveDetailsButton as HTMLButtonElement).disabled = false;
                showStatusMessage("Error occurred while processing your request", "error");
                HideLoading();
              });
            } catch (error) {
              HideLoading();
            }
          }
        },
        (error) => {
          (saveDetailsButton as HTMLButtonElement).disabled = false;
          showStatusMessage("Error occurred while processing your request", "error");
          HideLoading();
        }
      );
    } else {
      (saveDetailsButton as HTMLButtonElement).disabled = false;
      showStatusMessage("Validation error", "error");
    }
  } catch (error) {
    console.error("Failed to load stats:", error);
  }
}
async function loadEmailCheckSection() {
  detectEmailForChecking();
  //const addEmailButton = document.getElementById("addEmail-action") as HTMLButtonElement;
  //addEmailButton.disabled = true;
  const outlookAttachmentHTML = document.getElementById("outlookEmailBackupHTML");// as HTMLTableRowElement;
  if (outlookAttachmentHTML) {
    outlookAttachmentHTML.innerHTML = "";
    const rowElement = `<tr id="" class="">
    <td width="200px"><div id="tooltipHolder-emailContent" class="tltipHolder"><label><input type="checkbox" data-type="mail" name="attachmentBackupCheck" id="emailContentCheckBox" /><span class="emphasisContent">Email content</span></label><div class="tltip left" id="tooltip-emailContent"></div></div></td>
    <td width="76px"><div class="status-message status-info margin-0" id="emailCheck-status">Checking.. </div><button id="updateEmail-action" class="btn small btn-default margin-right-5 hidden">Update email</button></td> 
    </tr>
    <tr class="hidden" id="row-"><td colspan="2" id="result-relatedTo"></td></tr>`;
    outlookAttachmentHTML.innerHTML += rowElement;
  }
  try {
    ShowLoading();
    checkPermissionToCreate("activity").then((value:any) => {
      HideLoading();
      canCreateActivity = (value)? value.Result : false;;
    if(canCreateActivity){
      //addEmailButton.disabled = false;
    }
    },
      (error) => {
        showStatusMessage("Error occurred while processing your request", "error");
        HideLoading();
      });
  } catch {
    HideLoading();
  }
  setTimeout(()=>{
    document.getElementsByName("backToLandingSection-action").forEach((item)=>{
      item.onclick = backToLandingSection
    });
  }, 1000);
}
function detectEmailForChecking(){
  try {
    const item = Office.context.mailbox.item;
    // Handle case when no email is selected
    if (!item || !item.conversationId) {
      return;
    }
    ShowLoading();
    checkMailActiivityWithConversationId(item.conversationId).then(
      (value: checkEctivityMailResponse) => {
        HideLoading();
        const emailContentCheckBox = document.getElementById("emailContentCheckBox") as HTMLInputElement;
        const tooltipHolderDiv = document.getElementById(`tooltipHolder-emailContent`);
        if(value && value.OutlookConversationId && value.OutlookConversationId == item.conversationId){
          if(value.OutlookItemId == item.itemId){
            if(value.Activity && value.Activity.Tags){
              //const findRowResult = document.getElementById(`result-relatedTo`);
              const findRowResult = document.getElementById(`tooltip-emailContent`);
              findRowResult.innerHTML = ``;
              value.Activity.Tags.forEach((tag, index)=>{
                findRowResult.innerHTML += `<a class="_btn small margin-bottom-0 multiOptionDiv" target="_blank" href="${generateLinkToPams(tag.ReferenceToTypeID, tag.ReferenceToID)}" title="${tag.TagContent}">${tag.TagContent}</a>`;
              });
            }
            document.getElementById("emailCheck-status").innerHTML = "";//Exists
            document.getElementById("emailCheck-status").classList.remove("status-info");
            //document.getElementById("emailCheck-status").classList.add("status-success");
            if(tooltipHolderDiv) tooltipHolderDiv.classList.add("withTooltip");
            if(emailContentCheckBox) emailContentCheckBox.remove();
            document.getElementById("updateEmail-action").classList.add("hidden");
          }
          else{
            if(emailContentCheckBox) emailContentCheckBox.remove();
            document.getElementById("updateEmail-action").classList.remove("hidden");
            document.getElementById("updateEmail-action").addEventListener("click", ()=>{ updateEmail_action(value.Activity) });
          }
        }
        else{
            document.getElementById("emailCheck-status").innerHTML = "";
            document.getElementById("emailCheck-status").classList.remove("status-info");
          //document.getElementById("addEmail-action").classList.remove("hidden");
          //document.getElementById("addEmail-action").addEventListener("click", ()=>{ addEmail_action() });
        }
      },
      (error) => {
        showStatusMessage("Error occurred while processing your request", "error");
        HideLoading();
      }
    );
  } catch (error) {
    console.error('Failed to load contact stats:', error);
    HideLoading();
  }
}
async function addEmail_action(){
  async function getCurrentEmailBody(): Promise<string> {
    return new Promise((resolve) => {
      try {
        const item = Office.context.mailbox.item;
        if (!item) {
          resolve("");
          return;
        }

        item.body.getAsync(Office.CoercionType.Html, (result) => {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            resolve(result.value);
          } else {
            console.warn("Failed to get email body:", result.error?.message);
            resolve("");
          }
        });
      } catch (error) {
        console.error("Error getting current email body:", error);
        resolve("");
      }
    });
  }
  function getCurrentConversationId(): string | null {
    try {
      const item = Office.context.mailbox.item;
      if (!item) {
        console.log("No email item available");
        return null;
      }

      const conversationId = item.conversationId;
      console.log("Conversation ID:", conversationId);
      return conversationId;
    } catch (error) {
      console.error("Error getting conversation ID:", error);
      return null;
    }
  }
  function getCurrentItemId(): string | null {
    try {
      const item = Office.context.mailbox.item;
      if (!item) {
        console.log("No email item available");
        return null;
      }

      const itemId = item.itemId;
      console.log("Item ID:", itemId);
      return itemId;
    } catch (error) {
      console.error("Error getting conversation ID:", error);
      return null;
    }
  }
  const item = Office.context.mailbox.item;
  SelectedActivity.ActivityTypeID = ActivityTypesEnum.Mail;
  SelectedActivity.PriorityID = 2;
  SelectedActivity.CompanyBranchID = getStoredAuth().user.CompanyBranchID;
  SelectedActivity.StartDate = new Date();
  SelectedActivity.EndDate = new Date();
  SelectedActivity.PreparedByID = getStoredAuth().user.PersonID;
  SelectedActivity.Tags = [];
  SelectedActivity.Title = (item && item.subject)? item.subject: null;
  SelectedActivity.OutlookConversationId = getCurrentConversationId();
  SelectedActivity.OutlookItemId = getCurrentItemId();
  await getCurrentEmailBody().then((body)=>{
    SelectedActivity.Description = body;
  });
  SelectedActivity.ActivityEMails = [];
  if(item){
    SelectedActivity.ActivityEMails.push({ EMail:item.from.emailAddress, Type: ActivityEMailsTypesEnum.EmailFrom, ActivityEMailID:null, ActivityID: null });
    item.to.forEach((mail, index)=>{
      SelectedActivity.ActivityEMails.push({ EMail:mail.emailAddress, Type: ActivityEMailsTypesEnum.EmailTo, ActivityEMailID:null, ActivityID: null });
    });
    item.cc.forEach((mail, index)=>{
      SelectedActivity.ActivityEMails.push({ EMail:mail.emailAddress, Type: ActivityEMailsTypesEnum.EmailCC, ActivityEMailID:null, ActivityID: null });
    });
  }
  if (canCreateActivity) {
  }
}
async function getCurrentEmailBody(): Promise<string> {
  return new Promise((resolve) => {
    try {
      const item = Office.context.mailbox.item;
      if (!item) {
        resolve("");
        return;
      }

      item.body.getAsync(Office.CoercionType.Html, (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(result.value);
        } else {
          console.warn("Failed to get email body:", result.error?.message);
          resolve("");
        }
      });
    } catch (error) {
      console.error("Error getting current email body:", error);
      resolve("");
    }
  });
}
function getCurrentConversationId(): string | null {
  try {
    const item = Office.context.mailbox.item;
    if (!item) {
      console.log("No email item available");
      return null;
    }

    const conversationId = item.conversationId;
    console.log("Conversation ID:", conversationId);
    return conversationId;
  } catch (error) {
    console.error("Error getting conversation ID:", error);
    return null;
  }
}
function getCurrentItemId(): string | null {
  try {
    const item = Office.context.mailbox.item;
    if (!item) {
      console.log("No email item available");
      return null;
    }

    const itemId = item.itemId;
    console.log("Item ID:", itemId);
    return itemId;
  } catch (error) {
    console.error("Error getting conversation ID:", error);
    return null;
  }
}
async function updateEmail_action(activity: Activities) {
  const item = Office.context.mailbox.item;
  SelectedActivity = activity;
  SelectedActivity.ActivityID = activity.ActivityID;
  SelectedActivity.Title = (item && item.subject)? item.subject: null;
  SelectedActivity.OutlookConversationId = getCurrentConversationId();
  SelectedActivity.OutlookItemId = getCurrentItemId();
  await getCurrentEmailBody().then((body) => {
    SelectedActivity.Description = body;
  });
  SelectedActivity.ActivityEMails = [];
  if(item){
    SelectedActivity.ActivityEMails.push({ EMail: item.from.emailAddress, Type: ActivityEMailsTypesEnum.EmailFrom, ActivityEMailID: null, ActivityID: null });
    item.to.forEach((mail, index) => {
      SelectedActivity.ActivityEMails.push({ EMail: mail.emailAddress, Type: ActivityEMailsTypesEnum.EmailTo, ActivityEMailID: null, ActivityID: null });
    });
    item.cc.forEach((mail, index) => {
      SelectedActivity.ActivityEMails.push({ EMail: mail.emailAddress, Type: ActivityEMailsTypesEnum.EmailCC, ActivityEMailID: null, ActivityID: null });
    });
    if (canCreateActivity) {
      try {
        ShowLoading();
        saveMailActiivity(SelectedActivity).then((value) => {
          //backToLandingSection();
          HideLoading();
          checkExistingAuth();
        }
        ,(error)=>{
          HideLoading();
        });
      } catch (error) {
        HideLoading();
      }
    }
  }
}
function saveEmail_action(){
  try {
    if(tags && tags.length){
      SelectedActivity.Tags = tags;
    }
    if(SelectedActivity && SelectedActivity.Tags.length){
      ShowLoading();
      saveMailActiivity(SelectedActivity).then(
        (value:Activities) => {
          if (value ) {
            if(wantToSaveAttachment){
              const additionalTag: Tag = new Tag();
              additionalTag.TagRelatedToID = 0;
              additionalTag.TagRelatedTypeID = 1;
              additionalTag.ReferenceToID = value.ActivityID;
              additionalTag.ReferenceToTypeID = RelatedToTypes.Activity;
              additionalTag.TagContent = RelatedToTypes[RelatedToTypes.Activity] + ": " + value.Title;
              SaveFiles_action([additionalTag]);
            }
            else{
              HideLoading();
              backToLandingSection();
              checkExistingAuth();
            }
          }
        },
        (error) => {
          (saveDetailsButton as HTMLButtonElement).disabled = false;
          showStatusMessage("Error occurred while processing your request", "error");
          HideLoading();
        }
      );
    }
    else{
      (saveDetailsButton as HTMLButtonElement).disabled = false;
      showStatusMessage("Validation error", "error");
    }
  } catch (error) {
    console.error('Failed to load contact stats:', error);
    HideLoading();
  }
}
function resetAttachmentAndMailChoices(){
  if(categoryLookup) categoryLookup.value = null;
  if(moduleIdLookup) moduleIdLookup.value = null;
  if(moduleIdLookup) moduleIdLookup.innerHTML = "";
  if(tagsListSearch) tagsListSearch.value = null;
  if(tagsListLookup) tagsListLookup.value = null;
  tags = [];
}
function addDetailsForAttachmentAndMail(){
  function fillTypesList (){
    const moduleIds = TypesListForActivity;//TypesList
    //moduleIdLookup.innerHTML = "";
    //tags = [];
    if (moduleIdLookup) {
      moduleIds.forEach((acc, index) => {
        const messageElement = document.createElement("option");
        messageElement.value = acc.ID.toString();
        messageElement.innerHTML = acc.Name;
        moduleIdLookup.appendChild(messageElement);
      });
      moduleIdLookup.disabled = false;
    }
  }
  function onIncludingArchivedCheckBoxChange(isArchivedIncluded: string){
    if((includingArchivedCheckBox as HTMLInputElement).checked){
      fillTagsListSelectBox(+moduleIdLookup.value, true);
    }
    else{
      fillTagsListSelectBox(+moduleIdLookup.value, false);
    }
  }
  function fillTagsListSelectBox(listNum:number, isArchivedIncluded: boolean) {
    try {
      tagsListSearch.disabled = true;
      tagsListSearch.value = "";
      tagsListLookup.disabled = true;
      tagsListLookup.innerHTML = "";

      tagsList = [];
      ShowLoading();
      fetchTagsListByType(listNum, isArchivedIncluded).then(
        (value: TagsList[]) => {
          HideLoading();
          if (value) {
            tagsList = value;
            if (tagsListLookup) {
              tagsList.forEach((acc, index) => {
                const messageElement = document.createElement("option");
                messageElement.value = acc.ID.toString();
                messageElement.title = ((acc.ItemNo)? acc.ItemNo :"") + " - " + ((acc.Accounts)? acc.Accounts: "") + " - " + ((acc.Title)? acc.Title : "");
                //messageElement.title = acc.Name;
                messageElement.innerHTML = ((acc.ItemNo)? acc.ItemNo :"") + " - " + ((acc.Accounts)? acc.Accounts: "") + " - " + ((acc.Title)? acc.Title : "");
                //messageElement.innerHTML = acc.Name;
                tagsListLookup.appendChild(messageElement);
              });
              tagsListSearch.disabled = false;
              tagsListLookup.disabled = false;
              includingArchivedCheckBox.disabled = false;
              initializeSearchableSelect('tagsListSearch', 'tagsListLookup', tagsListLookup.options, tagsList, "ID", ["ItemNo", "Accounts", "Title"], false, true );
            }
            console.log("tagsListLookup: ", tagsList);
          }
        },
        (error) => {
          showStatusMessage("Error occurred while processing your request", "error");
          HideLoading();
        }
      );
    } catch {
      HideLoading();
    }
  }
  function fillUsersFilePermission(relatedToType: number, relatedToId: number) {
    try {
      if(relatedToType && relatedToId) {
        addTags(relatedToType, relatedToId);
        setTimeout(() => {
          tagsListSearch.value = "";
        }, 1000);
      }
      if(wantToSaveAttachment && !tempSelectedDataFiles.Users){
        if(addTagsButton) addTagsButton.disabled = false;
        tagsListSearch.disabled = true;
        tagsListLookup.disabled = true;
        moduleIdLookup.disabled = true;
        (saveDetailsButton as HTMLButtonElement).disabled = true;
        tempSelectedDataFiles.Users = [];
        ShowLoading();
        fetchFilePermissionByTypeAndRelatedToId(relatedToType, relatedToId).then(
          (value: any[]) => {
            HideLoading();
            if (value) {
              tempSelectedDataFiles.Users = value;
              }
              console.log("fillUsersFilePermission: ", value);
              tagsListSearch.disabled = false;
              tagsListLookup.disabled = false;
              moduleIdLookup.disabled = false;
              (saveDetailsButton as HTMLButtonElement).disabled = false;
          },
          (error) => {
            showStatusMessage("Error occurred while processing your request", "error");
            HideLoading();
          }
        );
      }
    } catch {
      HideLoading();
    }
  }
  function fetchCategories(){
    try {
      if(!categoriesForAttachment || categoriesForAttachment.length <= 1 || categoryLookup.innerHTML == ""){
        ShowLoading();
        categoriesForAttachment = [{Id: 0, Name: "-- Select category --"}];
        categoryLookup.innerHTML = "";
        fetchCategoriesListForAttachment().then(
          (value: {Id: number, Name: string}[]) => {
            HideLoading();
            if (value) {
              categoriesForAttachment = categoriesForAttachment.concat(value);
              if (categoryLookup) {
                categoriesForAttachment.forEach((acc, index) => {
                  const messageElement = document.createElement("option");
                  messageElement.value = acc.Id.toString();
                  messageElement.innerHTML = acc.Name;
                  categoryLookup.appendChild(messageElement);
                });
                categoryLookup.disabled = false;
              }
              console.log("fetchCategoriesListForAttachment: ", value);
            }
          },
          (error) => {
            showStatusMessage("Error occurred while processing your request", "error");
            HideLoading();
          }
        );
      }
      else{
        categoryLookup.disabled = false;
      }
    } catch {
      HideLoading();
    }
  }
  function fetchAttachmentContent() {
    try {
      selectedAttachmentContent = [];
      ShowLoading();
      for (let index = 0; index < selectedAttachment.length; index++) {
        getOutlookAttachmentContent(selectedAttachment[index].id).then(
          (value: {content: string, format: any}) => {
            if (value) {
              selectedAttachmentContent.push(value);
              console.log("fetchAttachmentContent: ", value);
            }
          },
          (error) => {
            showStatusMessage("Error occurred while processing your request", "error");
            HideLoading();
          }
        );
      }
      HideLoading();
    } catch {
      HideLoading();
    }
  }
  wantToSaveEmail = null;
  wantToSaveAttachment = null;
  const categoryLookupHolder = document.getElementById("categoryLookupHolder");
  const originalattchment = (Office.context.mailbox.item.attachments)? Office.context.mailbox.item.attachments : [];
  selectedAttachment = [];
  attachmentBackupCheckBoxes.forEach((input, index)=>{
    const attribute = (input as HTMLInputElement).getAttribute("data-type");
    if((input as HTMLInputElement).checked){
      if(attribute == "attachment"){
        wantToSaveAttachment = true;
        const findIndex = originalattchment.findIndex(x=> x.id == (input as HTMLInputElement).value);
        if(findIndex > -1){
          selectedAttachment.push(originalattchment[findIndex]);
        }
      }
      else if(attribute == "mail"){
        wantToSaveEmail = true;
      }
    }
  });
  if(wantToSaveEmail){
    addEmail_action();
  }
  if(wantToSaveAttachment){
    fetchAttachmentContent();
    addAttachment_action();
    categoryLookupHolder.style.display = "block";
  }
  else{
    categoryLookupHolder.style.display = "none";
  }
  document.getElementById('landingSection').style.display = "none";
  document.getElementById("addContactSection").style.display = "none";
  document.getElementById('addAccountSection').style.display = "none";
  document.getElementById('addDetailsToPamsSection').style.display = "block";
  moduleIdLookup = document.getElementById("moduleIdLookup") as HTMLSelectElement;
  moduleIdLookup.disabled = true;
  moduleIdLookup.addEventListener("change", ()=> fillTagsListSelectBox(+moduleIdLookup.value, false));
  includingArchivedCheckBox = (document.getElementById("includingArchivedCheckBox") as HTMLInputElement);
  includingArchivedCheckBox.addEventListener("change", ()=>{ onIncludingArchivedCheckBoxChange(includingArchivedCheckBox.value) });
  includingArchivedCheckBox.disabled = true;
  categoryLookup = document.getElementById("categoryLookup") as HTMLSelectElement;
  tagsListLookup = (document.getElementById("tagsListLookup") as HTMLSelectElement);
  tagsListSearch = (document.getElementById("tagsListSearch") as HTMLSelectElement);
  if(!moduleIdLookup || !moduleIdLookup.value){
    tagsListLookup.disabled = true;
    tagsListSearch.disabled = true;
    categoryLookup.disabled = true;
  }
  tagsListLookup.addEventListener("change", ()=> fillUsersFilePermission(+moduleIdLookup.value, +tagsListLookup.value));
  saveDetailsButton = (document.getElementById("saveAttachmentSection-action") as HTMLButtonElement);
  saveDetailsButton.addEventListener("click", ()=> { saveDetailsForAttachmentAndMail() });
  (saveDetailsButton as HTMLButtonElement).disabled = true;
  addTagsButton = (document.getElementById("addTags_action") as HTMLButtonElement);
  addTagsButton.addEventListener("click", ()=> addTags(+moduleIdLookup.value, +tagsListLookup.value));
  addTagsButton.disabled = true;
  fetchCategories();
  fillTypesList();
  drowSelectedTags();
}
function saveDetailsForAttachmentAndMail(){
  saveDetailsButton.disabled = true;
  saveDetailsButton.removeEventListener("click", ()=>{ saveDetailsForAttachmentAndMail() });
  if(wantToSaveEmail){
    saveEmail_action();
  }
  else if(!wantToSaveEmail && wantToSaveAttachment){
    SaveFiles_action();
  }
}
// Searchable Select Functionality
function initializeSearchableSelect(searchInputId, selectId, originalOptions:any[], originalList:any[], IdProp: string, displayProp:string[], withAddNew: boolean, includingArchived: boolean) {
    const searchInput = document.getElementById(searchInputId) as HTMLInputElement;
    const select = document.getElementById(selectId) as HTMLSelectElement;
    let sourceOptions:any[] = Array.from(originalOptions);
    let sourceList:any[] = Array.from(originalList);
    
    // Store source options
    function storeSourceOptions() {
        /*sourceOptions = Array.from(originalOptions).map(option => ({
            value: option.value,
            innerText: option.innerText,
            selected: option.selected
        }));*/
    }
    // Store source options
    function drowDropdownOptions(Options:any[]) {
      // Clear current options
      select.innerHTML = "";
      /*const value = IdProp;
      if(!sourceList.length && includingArchived){
        sourceList.unshift({ IdProp: "-100", Columns: "Search in archived too", selected: false })
      }
      if (withAddNew) {
          sourceList.unshift({ value: "-1", innerText: "Add new", selected: false })
      }*/
      Options.forEach((option, index) => {
            const optionElement = document.createElement('option');
            optionElement.value = option[IdProp];
              optionElement.innerText = "";
            displayProp.forEach((prop, index)=>{
              optionElement.innerText += (option[prop] && option[prop] != null)? option[prop] : "";
              if(displayProp.length - 1 > index){
                optionElement.innerText += " - ";
              }
            })
            //optionElement.innerText = option.innerText;
            optionElement.selected = option.selected;
            select.appendChild(optionElement);
      });
    }
    
    // Filter options based on search
    function filterOptions(searchTerm) {
      const filteredOptions = sourceOptions.filter(option => option.innerText.toLowerCase().includes(searchTerm.toLowerCase()));
      if(!filteredOptions.length && includingArchived){
        filteredOptions.unshift({ value: "-100", innerText: "Search in archived too", selected: false })
      }
      if (withAddNew) {
          filteredOptions.unshift({ value: "-1", innerText: "Add new", selected: false })
      }
      
      // Clear current options
      select.innerHTML = "";
      if(!filteredOptions.length && includingArchived){
        filteredOptions.unshift({ value: "-100", innerText: "Search in archived too", selected: false })
      }
      if (withAddNew) {
        filteredOptions.unshift({ value: "-1", innerText: "Add new", selected: false })
      }
      filteredOptions.forEach((option, index) => {
          const optionElement = document.createElement('option');
          optionElement.value = option.value;
          optionElement.innerText = option.innerText;
          optionElement.selected = option.selected;
          select.appendChild(optionElement);
      });

      // Show/hide select based on search term and results
      if (searchTerm && filteredOptions.length > 0) {
          select.style.display = 'block';
      } else if (!searchTerm) {
          //select.style.display = 'none';
      }
    }
    // Filter list based on search
    function filterList(searchValue: string) {
      let filteredOptions;
      if(displayProp.length > 1){
        // filter for tags list
        let searchTerms = searchValue.split('-').map(term => term.trim().toLowerCase()).filter(term => term.length > 0);
        filteredOptions = sourceList.filter(item => {
          return searchTerms.every(term =>
          item.ItemNo?.toLowerCase().includes(term) ||
          item.Accounts?.toLowerCase().includes(term) ||
          item.Title?.toLowerCase().includes(term)
          );
        });
      }
      else{
        // filter for accounts dropdown
        filteredOptions = sourceList.filter(item => item.Name.toLowerCase().includes(searchValue));
      }
      /*
      if(displayProp.length > 1){
        // filter for tags list with tokenized search
        // Split by hyphen, trim each token (removes spaces before/after), convert to lowercase, and filter out empty tokens
        let searchTerms = searchValue
          .split('-')
          .map(term => term.trim().toLowerCase()) // trim() removes spaces, toLowerCase() makes case-insensitive
          .filter(term => term.length > 0); // only keep non-empty tokens
        
        // Filter items where ALL tokens are found somewhere in the item's fields
        filteredOptions = sourceList.filter(item => {
          // For each token, check if it exists in ANY of the three fields
          return searchTerms.every(term => {
            // Convert all fields to lowercase for case-insensitive comparison
            const itemNo = item.ItemNo?.toLowerCase() || '';
            const accounts = item.Accounts?.toLowerCase() || '';
            const title = item.Title?.toLowerCase() || '';
            
            // Check if this token exists in any of the fields (case-insensitive)
            return itemNo.includes(term) || accounts.includes(term) || title.includes(term);
          });
        });
      }
      else{
        // filter for accounts dropdown - simple single field search (case-insensitive)
        const searchTerm = searchValue.toLowerCase();
        filteredOptions = sourceList.filter(item => {
          const name = item.Name?.toLowerCase() || '';
          return name.includes(searchTerm);
        });
      }
       */
        
        // Add filtered options
        drowDropdownOptions(filteredOptions);
        
        // Show/hide select based on search term and results
        if (searchValue && filteredOptions.length > 0) {
            select.style.display = 'block';
        } else if (!searchValue) {
            //select.style.display = 'none';
        }
    }
    
    // Initialize
    //storeSourceOptions();

    // Search input event
    searchInput.addEventListener('input', function() {
        const searchTerm = this.value;//.trim();
        filterList(searchTerm);
    });
    
    // Focus event - show dropdown if has search term
    searchInput.addEventListener('focus', function() {
        select.style.display = 'block';
        const searchTerm = this.value.trim();
        if (searchTerm) {
            filterList(searchTerm);
        }
    });
    
    // Blur event - hide dropdown after a delay
    searchInput.addEventListener('blur', function() {
        setTimeout(() => {
            select.style.display = 'none';
        }, 200);
    });
    
    // Select option event
    select.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        if (selectedOption && selectedOption.value) {
            searchInput.value = selectedOption.text;
            this.style.display = 'none';
        }
    });
    
    // Click on option
    select.addEventListener('click', function() {
        const selectedOption = this.options[this.selectedIndex];
        if (selectedOption && selectedOption.value) {
            searchInput.value = selectedOption.text;
            this.style.display = 'none';
        }
    });
    
    // Update original options when select is dynamically populated
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                //storeSourceOptions();
            }
        });
    });
    
    observer.observe(select, { childList: true });
    
    return {
        updateOptions: storeSourceOptions,
        search: filterList
    };
}
